export default "__VITE_ASSET__0jXxMmvt__"